module.exports = __webpack_public_path__ + "img/629.Hot_drink_cups.3e556e80.svg";